import { InventoryService } from '../../../services/inventory-service';
import * as InventoryActions from '../../inventory/inventory.actions';
import { RETURNS_SEND_LABEL_TO_EMAIL_REQUEST } from '../../returns/returns.actions';
import * as Actions from './orders.details.actions';

export const initialState = {
  isEditingOrderItems: false,
};

export const orderDetails = (state = initialState, action) => {
  switch (action.type) {
    case Actions.ORDER_DETAILS_MODAL_OPENED:
      return {
        ...state,
        isLoading: true,
        isModified: false,
        modalId: action.modalId,
        salesOrderId: action.salesOrderId,
        fulfillmentPlanId: action.fulfillmentPlanId,
      };
    case Actions.ORDER_DETAILS_MODAL_CLOSED:
      return {
        ...initialState,
        isModified: state.isModified,
        modalId: undefined,
      };
    case Actions.GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSilentlyGettingOrderDetails: false,
      };
    case Actions.SET_SELECTED_RETURN_ITEMS:
      return {
        ...state,
        isCreatingReturn: true,
        selectedReturnItems: action.selectedItems,
      };
    case Actions.SET_SELECTED_RETURN_SHIPMENT:
      return {
        ...state,
        selectedReturnShipment: action.fulfillmentId,
      };
    case Actions.EXIT_CREATE_RETURN:
      return {
        ...state,
        isCreatingReturn: false,
        selectedReturnItems: undefined,
        selectedReturnShipment: undefined,
        isReturnsFromShipment: false,
      };
    case Actions.MARK_AS_MODIFIED:
      return {
        ...state,
        isModified: true,
      };

    case RETURNS_SEND_LABEL_TO_EMAIL_REQUEST:
      return { ...state, isLoading: true };

    case InventoryActions.GET_STOCK_LEVELS_SUCCESS:
      return InventoryService.setupInventoryInfo(action.inventoryInfo, state);

    case InventoryActions.GET_STOCK_LEVELS_REQUEST:
      return { ...state, inventoryInfo: { isLoading: true } };

    case InventoryActions.GET_STOCK_LEVELS_FAILURE:
      return { ...state, inventoryInfo: { isLoading: false } };

    case Actions.SET_ORDER_GRID_META_DATA:
      return {
        ...state,
        meta: {
          canGoToPreviousOrder: action.canGoToPreviousOrder,
          canGoToNextOrder: action.canGoToNextOrder,
          previousOrderId: action.previousOrderId,
          nextOrderId: action.nextOrderId,
          showArrows: action.showArrows,
        },
      };
    case Actions.ORDER_DETAILS_MODAL_OPENED_FROM_SHIPMENT_FOR_RETURN:
      return {
        ...state,
        isReturnsFromShipment: action.isReturnsFromShipment,
        shipmentIdForReturns: action.shipmentIdForReturns,
      };

    case Actions.ORDER_DETAILS_FLIP_EDIT_ORDER_ITEMS:
      return {
        ...state,
        isEditingOrderItems: !state.isEditingOrderItems,
      };
    case Actions.ORDER_DETAILS_GO_TO_ROUTE:
      return {
        ...state,
        isCreatingReturn: false,
        isLoading: state.salesOrderId !== action.salesOrderId,
        modalId: state.modalId,
        salesOrderId: action.salesOrderId,
        fulfillmentPlanId: action.fulfillmentPlanId,
      };
    case Actions.SILENTLY_GET_ORDER_DETAILS:
      return {
        ...state,
        isSilentlyGettingOrderDetails: true,
        isEditingOrderItems: false,
        isEditingShipTo: false,
      };
    default:
      return state;
  }
};

export { namespace } from './orders.details.reducer.metadata';
